import {
  GET_CAMPAIGN_SURVEY_REQUESTING,
  GET_CAMPAIGN_SURVEY_SUCCESS,
  GET_CAMPAIGN_SURVEY_ERROR,
  SUBMIT_ANSWERS_ERROR,
  SUBMIT_ANSWERS_REQUESTING,
  SUBMIT_ANSWERS_SUCCESS,
  GET_ACTIVE_SURVEY_REQUESTING,
  GET_ACTIVE_SURVEY_SUCCESS,
  GET_ACTIVE_SURVEY_ERROR,
  GET_SURVEY_SUCCESS,
  GET_SURVEY_REQUESTING,
  GET_SURVEY_ERROR,
  SET_SURVEY,
  GET_ONBOARDING_SURVEY_REQUESTING,
  GET_ONBOARDING_SURVEY_SUCCESS,
  GET_ONBOARDING_SURVEY_ERROR,
} from "./constants";
import { LOGOUT } from "../login/constants";

const initialState = {
  requesting: false,
  error: "",
  survey: { title: {}, questions: [] },
  answers: [],
};

const reducer = function signupReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SURVEY_REQUESTING:
    case GET_ACTIVE_SURVEY_REQUESTING:
    case SUBMIT_ANSWERS_REQUESTING:
    case GET_CAMPAIGN_SURVEY_REQUESTING:
    case GET_ONBOARDING_SURVEY_REQUESTING:
      return {
        ...state,
        requesting: true,
      };

    case SUBMIT_ANSWERS_SUCCESS: {
      return {
        ...initialState,
      };
    }

    case GET_SURVEY_SUCCESS:
    case GET_CAMPAIGN_SURVEY_SUCCESS:
    case GET_ONBOARDING_SURVEY_SUCCESS:
    case GET_ACTIVE_SURVEY_SUCCESS: {
      return {
        ...state,
        survey: action.payload,
        requesting: false,
      };
    }

    case GET_SURVEY_ERROR:
    case GET_ACTIVE_SURVEY_ERROR:
    case SUBMIT_ANSWERS_ERROR:
    case GET_CAMPAIGN_SURVEY_ERROR:
    case GET_ONBOARDING_SURVEY_ERROR:
      return {
        ...state,
        error: action.payload,
        requesting: false,
      };

    case SET_SURVEY:
      return {
        ...state,
        ...action.payload,
      };

    case LOGOUT:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
